module.exports = __webpack_public_path__ + "img/ariana.abf5f987.jpeg";